import { Link } from 'react-router-dom';
import OverflowMenu from '../../utils/OverflowMenu';
import styles from '../CommentList.module.scss';

export function CommentAuthorCluster({
  userId,
  userAvatars,
  defaultAvatar,
  currentUser,
  menuOptions,
  timestamp,
  formatTimestamp,
  handleUserPageNavFromSong,
}) {
  return (
    <div className={styles.userCluster}>
      <Link
        to={
          userAvatars[userId]?.handle
            ? `/user/@${userAvatars[userId].handle}`
            : `/user/${userId}`
        }
        className={styles.userLink}
        onClick={(e) => {
          e.preventDefault();
          handleUserPageNavFromSong(userId);
        }}
      >
        <img
          src={userAvatars[userId]?.avatar || defaultAvatar}
          alt={userAvatars[userId]?.displayName || 'Unknown User'}
          className={styles.avatar}
        />
        <div className={styles.infoStacked}>
          <div className={styles.nameRow}>
            <span className={styles.userName}>
              {userAvatars[userId]?.displayName || 'Unknown User'}
            </span>
            {userAvatars[userId]?.handle && (
              <span className={styles.handle}>
                @{userAvatars[userId].handle}
              </span>
            )}
          </div>
          <span className={styles.postTime}>{formatTimestamp(timestamp)}</span>
        </div>
      </Link>
      {currentUser && userId === currentUser?.uid && (
        <OverflowMenu options={menuOptions} />
      )}
    </div>
  );
}
